<template>
  <div id="container">
    <div class="location">
      <ul>
        <li class="home">홈</li>
        <li>적하보험</li>
        <li>상품안내</li>
        <li>보험의 개시와 종료</li>
      </ul>
    </div>

    <div class="pageTit">
      <div class="conWrap">
        <h2>보험의 개시와 종료</h2>
        <div class="depLink">
          <button type="button" title="메뉴">
            <span>보험의 개시와 종료</span>
          </button>
          <ul>
            <li>
              <router-link to="/insursumCargoidm"
                ><span>적하보험의 개요</span></router-link
              >
            </li>
            <li>
              <router-link to="/cargotarProdguid"
                ><span>적하보험의 가입대상</span></router-link
              >
            </li>
            <li>
              <router-link to="/condcovProdguid"
                ><span>조건별 담보안내</span></router-link
              >
            </li>
            <li>
              <router-link to="/insurstrtProdguid"
                ><span>보험의 개시와 종료</span></router-link
              >
            </li>
            <li>
              <router-link to="/premcalProdguid"
                ><span>보험료 산출 및 납입</span></router-link
              >
            </li>
            <li>
              <router-link to="/blaninsurProdguid"
                ><span>포괄보험 안내</span></router-link
              >
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="contents">
      <div class="conWrap">
        <div class="conStyle3">
          <p class="tit">보험의 개시</p>
          <p class="txt">
            화물이 보험증권에 기재된 지역의 창고 또는 장치장에서 운송시작을 위해
            출발한 때 위험의 담보가 개시됩니다.<br />
            즉, 운송을 위해 창고에 보관 중 이거나 운송용구(육상)에 적재되는
            동안은 담보되지 않으며<br />
            <span class="fcRed">운송 개시를 위해 떠날 때</span> 적하 보험의
            효력이 발생합니다.
          </p>
        </div>
      </div>

      <div class="conStyle4">
        <div class="conWrap">
          <p class="tit">보험의 종료</p>
          <p class="txt">
            약관상 적하보험의 위험은
            <span class="fcRed">다음 3가지 중에서 어느 것이 먼저 발생</span
            >하든<br />
            그때 담보가 종료 되도록 규정하고 있습니다.
          </p>
          <ol>
            <li>
              <span>01</span>
              보험증권에 기재된 목적지에<br />
              수화주, 기타의 최종창고 또는<br />
              보관장소에 인도될 때
            </li>
            <li>
              <span>02</span>
              최종 양하항에서 하역한 후<br />
              60일(수입화물은 30일)이<br />
              경과한 때
            </li>
            <li>
              <span>03</span>
              통상의 운송 과정을 벗어난 보관이나,<br />
              할당 또는 분배를 위하여<br />
              사용하고자 하는 기타의 창고 또는<br />
              보관장소에 인도될 때
            </li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// @ is an alias to /src

import { ref, reactive, inject, onMounted, onBeforeUpdate } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import util from "@/common/util";
import { sessionUserInfo, load } from "@/common/sessionFactory";
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";
</script>

<style></style>
